import api from "../../core/api";
import { Category, ChangeCategory } from "../models/AdminProductsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class AdminCategoriesApi {
  getCategories(): Promise<Category[]> {
    return api.get<Category[]>(`/v1/admin/categories`, getRequestConfig()).then(x => x.data);
  }

  createCategory(model: ChangeCategory): Promise<void> {
    return api.post('/v1/admin/categories', model, getRequestConfig());
  }

  changeCategory(id: string, category: ChangeCategory): Promise<any> {
    return api.put(`/v1/admin/categories/${id}`, category, getRequestConfig());
  }
}

export default new AdminCategoriesApi();